import { useRouter } from "next/router";
import Link from "next/link";
import { useEffect, useContext } from "react";
import { PageTitle } from "@/components/molecules";
import { ErrorWords } from "@/components/organisms/ErrorWords";
import { MainTemplate } from "@/components/templates";
import { linkStyle } from "@/styles/sharedStyle";
import { getUrlWithQuery } from "@/libs/url";
import { AuthContext, AuthStatus } from "@/contexts/AuthContext";
import useFixedAuth from "@/libs/useFixedAuth";

export const VerifyEmailAddressCompletedPage = () => {
  const router = useRouter();
  const { app } = router.query;
  const { authStatus } = useFixedAuth();
  const { signOut } = useContext(AuthContext);

  useEffect(() => {
    if (authStatus != AuthStatus.SignedOut) {
      signOut();
      return;
    }
  });

  return (
    <MainTemplate title={`メールアドレスの認証`}>
      <PageTitle mainTitle={`メールアドレスの認証`} />
      <ErrorWords>
        <>
          メールアドレスの認証が完了しました。
          <br />
          再ログインをお願いします
        </>
        <br />
        <Link href={getUrlWithQuery("/", app)}>
          <a css={linkStyle}>TOP</a>
        </Link>
      </ErrorWords>
    </MainTemplate>
  );
};
